import React from "react";
import { Card, Button, Typography, Space } from "antd";

const { Title, Paragraph, Text } = Typography;

export default function LoadBalancers() {
  return (
    <Space
      direction="vertical"
      size="large"
      style={{ width: "100%" }}
    >
      <Card>
        <Title level={5}>LOAD BALANCERS</Title>

        <Paragraph>
          Load Balancers distribute traffic between multiple
          target servers. You can assign this server to a
          Load Balancer as a target.
        </Paragraph>

        <Paragraph>
          <Text type="secondary">
            Server is not assigned to any Load Balancers yet.
          </Text>
        </Paragraph>

        <Button disabled>
          Assign to Load Balancer
        </Button>
      </Card>
    </Space>
  );
}
